import { useCallback, useEffect, useRef } from 'react';
import axios from 'axios';

export default function useAsyncPdf({ token, pollInterval = 2000 } = {}) {
  const pollRef = useRef(null);

  const stopPoll = useCallback(() => {
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
  }, []);

  useEffect(() => () => stopPoll(), [stopPoll]);

  const generatePdf = useCallback(({ startFn, statusUrlFn, fileUrlFn }) => {
    stopPoll();

    return new Promise((resolve, reject) => {
      startFn()
        .then(res => {
          const data = res.data || res;
          const jobId = data.jobId;
          if (!jobId) {
            reject(new Error('Resposta inválida do servidor.'));
            return;
          }

          const poll = () => {
            axios
              .get(statusUrlFn(jobId), { headers: { Authorization: `Bearer ${token}` } })
              .then(statusRes => {
                const { status, message, missingFields } = statusRes.data || {};
                if (status === 'PRONTO') {
                  stopPoll();
                  axios
                    .get(fileUrlFn(jobId), {
                      headers: { Authorization: `Bearer ${token}` },
                      responseType: 'blob',
                    })
                    .then(fileRes => {
                      const blob = new Blob([fileRes.data], { type: 'application/pdf' });
                      resolve({ blob, missingFields: missingFields || null, jobId });
                    })
                    .catch(reject);
                } else if (status === 'ERRO' || status === 'CHEIO') {
                  stopPoll();
                  reject(new Error(message || 'Erro ao gerar o PDF.'));
                }
              })
              .catch(err => { stopPoll(); reject(err); });
          };

          poll();
          pollRef.current = setInterval(poll, pollInterval);
        })
        .catch(reject);
    });
  }, [token, pollInterval, stopPoll]);

  return generatePdf;
}
